<form [formGroup]="fg" (submit)="onSubmit()" class="card">
  <div class="card-header">Generate Voucher</div>
  <div class="card-body" mat-dialog-content>
    <div class="grid grid-cols-12 gap-x-4">

      <div class="col-span-12 md:col-span-6">
        <div class="mb-4">
          <label for="PayToTheOrderOf" class="form-label">Pay to the order of <span
              class="text-red-400">*</span></label>
          <input [formControl]="fg.controls.PayToTheOrderOf" type="text" id="PayToTheOrderOf" class="form-control">
          <small *ngIf="fg.controls.PayToTheOrderOf.invalid && fg.controls.PayToTheOrderOf.touched"
            class="text-red-400">
            * Pay to the order of is required.
          </small>
        </div>
      </div>
      <div class="col-span-12 md:col-span-6">
        <div class="mb-4">
          <label for="Payee" class="form-label">Payee <span class="text-red-400">*</span></label>
          <input [formControl]="fg.controls.Payee" type="text" id="Payee" class="form-control">
          <small *ngIf="fg.controls.Payee.invalid && fg.controls.Payee.touched" class="text-red-400">
            * Payee is required.
          </small>
        </div>
      </div>
      <div class="col-span-12 md:col-span-6">
        <div class="mb-4">
          <label for="Amount" class="form-label">Amount <span class="text-red-400">*</span></label>
          <input [formControl]="fg.controls.Amount" type="number" id="Amount" class="form-control"
            (keypress)="Helper.input.positiveNumeric($event)">
          <small *ngIf="fg.controls.Amount.invalid && fg.controls.Amount.touched" class="text-red-400">
            * Amount is required.
          </small>
        </div>
      </div>
      <div class="col-span-12 md:col-span-6">
        <div class="mb-4">
          <label for="VATReg" class="form-label">VAT Reg <span class="text-red-400">*</span></label>
          <input [formControl]="fg.controls.VATReg" type="number" id="VATReg" class="form-control"
            (keypress)="Helper.input.positiveNumeric($event)">
          <small *ngIf="fg.controls.VATReg.invalid && fg.controls.VATReg.touched" class="text-red-400">
            * VATReg is required.
          </small>
        </div>
      </div>
      <div class="col-span-12">
        <div class="mb-4">
          <label for="Particulars" class="form-label">Particulars <span class="text-red-400">*</span></label>
          <input [formControl]="fg.controls.Particulars" type="text" id="Particulars" class="form-control">
          <small *ngIf="fg.controls.Particulars.invalid && fg.controls.Particulars.touched" class="text-red-400">
            * Particulars is required.
          </small>
        </div>
      </div>

    </div>

    <ng-container formArrayName="VoucherItems">
      <div class="font-bold text-lg mb-4">Voucher Items</div>

      <div *ngFor="let form of fg.controls.VoucherItems.controls; let formI = index" class="border p-4 mb-4">
        <div [formGroup]="form" class="grid grid-cols-12 gap-x-4">
          <div class="col-span-12">
            <div class="flex justify-between mb-4">
              <div class="font-bold">Item #{{formI + 1}}</div>
              <button [disabled]="waitHandler.processing" (click)="removeVoucherItem(formI)"
                class="custom-button custom-button-primary custom-button-sm" type="button">
                <i class="fal fa-trash"></i> Remove Item
              </button>
            </div>
          </div>
          <div class="col-span-12">
            <div class="mb-4">
              <label for="AccountCode-{{formI}}" class="form-label">Account Code <span
                  class="text-red-400">*</span></label>
              <app-acc-auto-complete-input [formGroupAttr]="form" [formControlAttr]="form.controls.AccountCode"
                [options]="chartAccList$|async"></app-acc-auto-complete-input>
              <small *ngIf="form.controls.AccountCode.invalid && form.controls.AccountCode.touched"
                class="text-red-400">
                * AccountCode is required.
              </small>
            </div>
          </div>
          <div class="col-span-12">
            <div class="mb-4">
              <label for="SubAccount-{{formI}}" class="form-label">Sub Account <span
                  class="text-red-400">*</span></label>
              <input [formControl]="form.controls.SubAccount" type="text" id="SubAccount-{{formI}}"
                class="form-control">
              <small *ngIf="form.controls.SubAccount.invalid && form.controls.SubAccount.touched" class="text-red-400">
                * SubAccount is required.
              </small>
            </div>
          </div>
          <div class="col-span-12">
            <div class="mb-4">
              <label for="Description-{{formI}}" class="form-label">Description <span
                  class="text-red-400">*</span></label>
              <input [formControl]="form.controls.Description" type="text" id="Description-{{formI}}"
                class="form-control">
              <small *ngIf="form.controls.Description.invalid && form.controls.Description.touched"
                class="text-red-400">
                * Description is required.
              </small>
            </div>
          </div>
          <div *ngIf="passedData.Type != 'Cash Advance'" class="col-span-12 md:col-span-6">
            <div class="mb-4">
              <label for="Debit-{{formI}}" class="form-label">Debit <span class="text-red-400">*</span></label>
              <input [formControl]="form.controls.Debit" type="number" id="Debit-{{formI}}" class="form-control"
                (keypress)="Helper.input.positiveNumeric($event)">
              <small *ngIf="form.controls.Debit.invalid && form.controls.Debit.touched" class="text-red-400">
                * Debit is required.
              </small>
            </div>
          </div>
          <div class="col-span-12 md:col-span-6">
            <div class="mb-4">
              <label for="Credit-{{formI}}" class="form-label">Credit <span class="text-red-400">*</span></label>
              <input [formControl]="form.controls.Credit" type="number" id="Credit-{{formI}}" class="form-control"
                (keypress)="Helper.input.positiveNumeric($event)">
              <small *ngIf="form.controls.Credit.invalid && form.controls.Credit.touched" class="text-red-400">
                * Credit is required.
              </small>
            </div>
          </div>
        </div>
      </div>

      <div class="form-submit mb-4">
        <button [disabled]="waitHandler.processing" (click)="newVoucherItem()"
          class="custom-button custom-button-primary custom-button-sm" type="button">
          <i class="fal fa-plus-circle"></i> Add Item
        </button>
      </div>
    </ng-container>
  </div>
  <div class="card-footer">
    <hr class="mb-4">
    <div *ngIf="prompt.message" class="alert alert-{{prompt.type}}">{{prompt.message}}</div>
    <div class="form-submit">
      <button [disabled]="waitHandler.processing" class="custom-button custom-button-primary"
        type="submit">Generate</button>
      <button [disabled]="waitHandler.processing" class="custom-button" type="button"
        mat-dialog-close="">Cancel</button>
    </div>
  </div>
</form>